import { primary } from 'foundation/colors';
import { createUseStyles } from 'react-jss';

type SpinnerProps = {
    fill?: string;
    size?: number;
};

const styles = createUseStyles({
    '@keyframes spin': {
        from: { transform: 'rotate(0deg)' },
        to: { transform: 'rotate(360deg)' },
    },
    loadingSpinner: {
        animation: '$spin 1s infinite linear',
        fill: (props: SpinnerProps) => props.fill || primary,
        height: (props: SpinnerProps) => props.size || undefined,
        width: (props: SpinnerProps) => props.size || undefined,
    },
});

export default styles;
